<template>
  <div class="not-found">
    <img src="~@/assets/images/sally-logo-full.svg" @click="goback()"/>
    <div class="wrapper" v-if="isIEBrowser">
      <div class="message">{{$t('not_support_ie1')}}</div>
      <div class="description">
        <span>{{$t('not_support_ie2')}}</span>
        <span>{{$t('not_support_ie3')}}</span>
      </div>
    </div>
    <div class="wrapper" v-else-if="isMobile">
      <div class="message">{{$t('not_support_mobile1')}}</div>
      <div class="description">
        <span>{{$t('not_support_mobile2')}}</span>
      </div>
    </div>
    <div class="wrapper" v-else>
      <div class="icon"></div>
      <div class="message">{{message}}</div>
    </div>
  </div>
</template>

<script>
import bus from '@/common/bus.util';
import { errorType } from '@/assets/js/code';

export default {
  name: 'NotFound',
  created() {
    this.message = this.$route.params.message || 'Not Found';
    bus.$emit('end:spinner');
  },
  computed: {
    isIEBrowser() {
      return this.$route.params.type === errorType.NOT_SUPPORT_IE;
    },
    isMobile() {
      return this.$route.params.type === errorType.NOT_SUPPORT_MOBILE;
    },
  },
  data() {
    return {
      message: '',
    };
  },
  methods: {
    goback() {
      this.$router.go(-2);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/style/variable.scss";
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 88px;
  }
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px;
  }
  .title {
    margin-top: 48px;
    margin-bottom: 28px;
    font-size: $font_size_22;
    font-weight: bold;
    color: #2A324B;
  }
  .description {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #4A4A4A;
  }
}
</style>
